import React, { useState } from 'react';
import {
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane
} from 'mdb-react-ui-kit';
import Project from './Project';
import Internships from './internship';
import Certificate from './Certificates';

export default function App() {
  const [fillActive, setFillActive] = useState('tab1');

  const handleFillClick = (value: string) => {
    if (value === fillActive) {
      return;
    }

    setFillActive(value);
  };

  return (
    <>
    {/* <center>
          <h1 className='h1' >Works</h1>
          <p className='p' >Throughout my career, I have completed a variety of impactful projects, showcasing my expertise and dedication in front-end development:
          </p>
        </center> */}
       
      <center ><h1 className='m-heading'>My<span className='m-span'> Portfolio</span></h1>
      <p className='p' style={{fontSize:"15px"}} >Throughout my career, I have completed a variety of impactful projects, showcasing my expertise and dedication in front-end development</p>
</center>
      <MDBTabs fill className='mb-4' style={{width:'80%', margin:"auto"}}>
        <MDBTabsItem >
          <MDBTabsLink onClick={() => handleFillClick('tab1')} active={fillActive === 'tab1'}>
            Projects
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleFillClick('tab2')} active={fillActive === 'tab2'}>
            Internships
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleFillClick('tab3')} active={fillActive === 'tab3'}>
            Certificates
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent>
        <MDBTabsPane open={fillActive === 'tab1'}><Project/></MDBTabsPane>
        <MDBTabsPane open={fillActive === 'tab2'}><Internships/></MDBTabsPane>
        <MDBTabsPane open={fillActive === 'tab3'}><Certificate/></MDBTabsPane>
      </MDBTabsContent>
    </>
  );
}